import { Image } from "antd";
import { Mask } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, NoMoreReminder } from "../../../../components";
import { useLogin } from "../../../../context/LoginContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { envChangeType, envType } from "../../../../plugins/utils";
import { usePopupContext } from "../../context/PopupContext";
import { popupSortingEnum } from "../../enumeration/popupSortingEnum";
import { setTomorrowCheck, tomorrowCheck } from "../../utils";
import styles from "./style.module.scss";

const EventPopup = ({}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userInfo } = useLogin();
  const { sorting, setNextSorting } = usePopupContext();
  const currency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);
  const tomorrowCheckTime = JSON.parse(localStorage.getItem(localStorageKey.TOMORROW_CHECK_TIME));
  const [visible, setVisible] = useState(false);
  const [checked, setChecked] = useState(false);
  const timeName = "eventPopupTime";

  //Only for colorwins right now, change as config if another plat needs
  const listEnum = [
    { target: 200000, bonus: 10000 },
    { target: 100000, bonus: 5000 },
    { target: 30000, bonus: 2000 },
    { target: 10000, bonus: 600 },
    { target: 3000, bonus: 300 },
    { target: 1000, bonus: 150 },
    { target: 300, bonus: 60 },
    { target: 100, bonus: 20 },
  ];

  const closeModal = () => {
    setTomorrowCheck(tomorrowCheckTime, checked, userInfo, timeName);
    setNextSorting();
    setVisible(false);
  };

  useEffect(() => {
    if (!userInfo || popupSortingEnum[timeName].sorting !== sorting) return;
    if (envChangeType("REACT_APP_SHOW_EVENT_POPUP", envType.BOOLEAN)) {
      tomorrowCheck(tomorrowCheckTime, setVisible, userInfo, timeName, "", setNextSorting);
    } else {
      setNextSorting();
    }
  }, [userInfo, sorting]);

  return (
    <Mask visible={visible} opacity="thick" onMaskClick={closeModal}>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <div className={styles.header}>
            <Image
              src={`/images/home/event_popup_header.png`}
              alt="event_popup_header"
              preview={false}
              width={284}
            />
          </div>
          <div className={styles.listContainer}>
            {listEnum.map((item, index) => {
              return (
                <div className={styles.list} key={index}>
                  <div className={styles.topContent}>
                    <div
                      className={styles.title}
                      dangerouslySetInnerHTML={{
                        __html: t("home.eventPopup.list.title", {
                          target: moneyFormat(item.target),
                        }),
                      }}
                    />
                    <div className={styles.bonus}>
                      +{t(`currency.symbol.${currency}`)}
                      {moneyFormat(item.bonus)}
                    </div>
                  </div>
                  <div className={styles.bottomContent}>
                    <div
                      className={styles.desc}
                      dangerouslySetInnerHTML={{
                        __html: t("home.eventPopup.list.desc", {
                          target: moneyFormat(item.target),
                          bonus: moneyFormat(item.bonus),
                        }),
                      }}
                    />
                    <Button
                      type="text"
                      className={`${styles.btn}`}
                      onClick={() => {
                        closeModal();
                        navigate("/exchange");
                      }}
                    >
                      {t("home.eventPopup.list.btn")}
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
          <Button
            block={true}
            size={"large"}
            type={"primary"}
            className={styles.confirmButton}
            onClick={() => closeModal()}
          >
            {t("home.eventPopup.btn")}
          </Button>
        </div>
        <NoMoreReminder checked={checked} setChecked={setChecked} />
      </div>
    </Mask>
  );
};

export default EventPopup;
